<script>
export default {
  props: ["disabled", "color"],
  computed: {
    fillColor() {
      return this.disabled ? "rgba(0, 0, 0, 0.25)" : "#004A98";
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// IconBase.vue?468c9720